module.exports = __webpack_public_path__ + "media/images/flags/nl-21eb77dcfa38c6d7bb81fb3d3ab4a7cf.svg";